import { Company } from '../company/company.model';

export class Contact {
    constructor(
        public id?: number,
        public deleted?: boolean,
        public version?: number,
        public type?: string,
        public title?: string,
        public firstName?: string,
        public lastName?: string,
        public email?: string,
        public job?: string,
        public phone?: string,
        public company?: Company,
        public initialized?: boolean,
        public emailingMode: string = 'CONTACT_AND_STUDENTS'
    ) {}
}



// WEBPACK FOOTER //
// ./src/app/_services/contact/contact.model.ts